import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { PrepaidCardGiftBoxResponse } from '@models/prepaidCard';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    gift: PrepaidCardGiftBoxResponse;
}

function GiftInfoSection({ gift }: Props) {
    const { t } = useTranslation('prepaidCard');
    const expiredLabel = gift.expiredAt
        ? t('giftDetail.until', {
            date: dayjs(gift.expiredAt).format('YYYY.MM.DD'),
        })
        : '-';

    return (
        <Container>
            <Text size='body-short' color={colors.textSecondary}>{t('giftDetail.sender')}</Text>
            <Text fontWeight='regular' color={colors.textSecondary}>{gift.senderName}</Text>

            <Text size='body-short' color={colors.textSecondary}>{t('giftDetail.status')}</Text>
            <Text fontWeight='regular' color={colors.textSecondary}>
                {t(`giftBox.status.${gift.status}`)}
            </Text>

            <Text size='body-short' color={colors.textSecondary}>{t('giftDetail.usable')}</Text>
            <Text fontWeight='regular' color={colors.textSecondary}>
                {t('giftDetail.usableValue')}
            </Text>

            <Text size='body-short' color={colors.textSecondary}>{t('giftDetail.validPeriod')}</Text>
            <Text fontWeight='regular' color={colors.textSecondary}>{expiredLabel}</Text>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    border: 1px solid var(--color-gray2);
    border-radius: 8px;
    display: grid;
    gap: 8px 0;
    grid-template-columns: 100px 1fr;
    padding: 16px;
    width: 100%;

    & :nth-child(2n) {
        text-align: right;
    }
`;

export default GiftInfoSection;
